export default{
    setSearchingData(state, data) {
        state.searchingData.per_page = data.per_page
        state.searchingData.page = data.page
        state.searchingData.search = data.search
        state.searchingData.sort = data.sort
    },
    resetSearchingData(state, data){
        state.searchingData = {
            per_page: 10,
            page: 1,
            search: {
                general: ''
            },
            sort: {
                key: 'receive_datetime',
                asc: false
            }
        }
    }
}